import styled from "styled-components";

export const List = styled.ul`
  margin: 0;
  list-style: none;
`;

export const ListItem = styled.li`
  display: flex;
`;
export const Section = styled.div`
  width: 33%;
`;
